import request from "@/utils/request";
//获取未审批付款纪录列表
export function getPaymentListApi(data) {
  return request({
    url: `/fmsapi/PaymentRecord/GetPaymentList`,
    method: "post",
    data,
  });
}
// 查询收款方
export function getPaymentRecordFun(data) {
  return request({
    url: `/fmsapi/PaymentRecord/GetPaymentRecord`,
    method: "post",
    data,
  });
}

// 查询付款方
export function getReceivablesListFun(data) {
  return request({
    url: `/fmsapi/ReceivablesRecord/GetReceivablesList`,
    method: "post",
    data,
  });
}

// 查询凭证
export function getALLVoucherFun(data) {
  return request({
    url: `/fmsapi/Voucher/GetALLVoucher`,
    method: "post",
    data,
  });
}

// 删除付款记录
export function delPaymentRecordFun(data) {
  return request({
    url: `/fmsapi/PaymentRecord/DelPaymentRecord`,
    method: "post",
    data,
  });
}

// 收款单位
export function getPartnersAllFun(data) {
  return request({
    url: `/fmsapi/common/GetPartnersAll`,
    method: "post",
    data,
  });
}

// 银行账户
export function getBankInfoFun(data) {
  return request({
    url: `/fmsapi/common/GetBankInfo`,
    method: "post",
    data,
  });
}
// 资金类别
export function getPayOrReceivablesTypeFun(data) {
  return request({
    url: `/fmsapi/common/GetPayOrReceivablesType`,
    method: "post",
    data,
  });
}

// 付款子类别
export function getStreamAccountShipFun(data) {
  return request({
    url: `/fmsapi/PaymentRecord/GetStreamAccountShip`,
    method: "post",
    data,
  });
}

// 创建付款记录
export function createPaymentRecordFun(data) {
  return request({
    url: `/fmsapi/PaymentRecord/CreatePaymentRecord`,
    method: "post",
    data,
  });
}
// 创建收款记录
export function createReceivablesRecordFun(data) {
  return request({
    url: `/fmsapi/ReceivablesRecord/CreateReceivablesRecord`,
    method: "post",
    data,
  });
}

// 删除收款记录
export function delReceivablesRecordFun(data) {
  return request({
    url: `/fmsapi/ReceivablesRecord/DelReceivablesRecord`,
    method: "post",
    data,
  });
}

// 更新收入外收款
export function updReceivablesDeclareCustomerFun(data) {
  return request({
    url: `/fmsapi/ReceivablesDeclareCustomer/UpdReceivablesDeclareCustomer`,
    method: "post",
    data,
  });
}
